import { Component, OnInit } from '@angular/core';
import { DataGridTemplate } from '../../../../shared/data-grid/data-grid.template';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormDialogTemplate } from '../../../../shared/form-dialog/form-dialog.template';
import { BehaviorSubject, Subject } from 'rxjs';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { PartTypeService } from '../../phf.service';
import { SortDescriptor } from '@progress/kendo-data-query';


@Component({
  selector: 'part-type',
  templateUrl: './part-type.component.html'
})
export class PartTypeComponent extends DataGridTemplate implements OnInit {
  editForm: FormGroup;
  formDialog: FormDialogTemplate;
  dialogTitle: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly PartTypeService: PartTypeService,
  ) {
    super();
  }

  ngOnInit() {
    this.httpErrorHeader = "Part type Error";
    this.filterable = "menu";
    this.formDialog = new FormDialogTemplate();
    this.modal = true;
    this.formDialog.setHeight(480);
    this.controls.excel = true;
    this.editForm = this.formBuilder.group({
      Id: [],
      Description: ['', Validators.required],
    });
    this.formDialog.initilize(this.dialogTitle, this.editForm, this.formDialogTabs);

    this.dialogTitle.next('Part Type');
  }

  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.dialogTitle.complete();
  }

  read(opts: any): Promise<any> {
    if (opts.force) {
      return this.PartTypeService.read()
        .then(response => {
          return response;
        })
    }
    else {
      return Promise.resolve(this.PartTypeService.value);
    }
  }

  create(parentEditDataItem: any): void {
    this.formDialog.isNew = true;
    this.formDialog.next({});
  }


  edit(dataItem: any): void {
    this.formDialog.isNew = false;
    this.formDialog.next(dataItem);
  }

  save(dataItem: any, isNew: boolean): Promise<any> {
    return isNew ?
      this.PartTypeService.save(dataItem, isNew, "", false)
      : this.PartTypeService.save(dataItem, isNew, "/" + dataItem.Id, false);
  }

  delete(dataItem: any): Promise<any> {
    return this.PartTypeService.remove('/' + dataItem.Id, false);
  }

  columns: any[] = [
    {
      field: 'Description',
      title: 'Description',
      width: '*',
      sortable: false,
    },
  ]
  formControls = [
    {
      type: "textarea",
      name: "Description",
      title: "Description",
      stretch: true,
    },
  ]

  formDialogTabs = [
    {
      title: "Part Type",
      selected: true,
      formControls: this.formControls
    },
  ]
}
